import type { OwnerApplyDetailsResponse } from "wagAPI";
export const registerOwnerApplyDetailsResponseParser = (response: OwnerApplyDetailsResponse) => response;